import React from "react";
import Dropzone from "react-dropzone";

const ResourceFileUpload = ({
  label,
  onDrop,
  onFilesSelected,
  accept,
  error,
  progress,
  children
}) => {
  // If progress is a boolean (resource file upload), show spinner overlay
  // If progress is a number (preview image upload), show progress bar
  const isBooleanProgress = typeof progress === 'boolean';
  const isNumberProgress = typeof progress === 'number';
  return (
    <div className="mb-3 position-relative">
      {/* <label className="form-label">{label}</label> */}
      <Dropzone onDrop={onFilesSelected || onDrop} accept={accept}>
        {({ getRootProps, getInputProps }) => (
          <section className="bg-light text-center p-4 border rounded">
            <div {...getRootProps()}>
              <input {...getInputProps()} />
              <span className="text-muted small">
                Drag 'n' drop some files here, or click to select files
              </span>
            </div>
          </section>
        )}
      </Dropzone>
      {/* Spinner overlay for boolean progress (resource file upload) */}
      {isBooleanProgress && progress && (
        <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center" style={{background: 'rgba(255,255,255,0.7)', zIndex: 10}}>
          <div className="spinner-border text-primary" role="status" style={{width: '2.5rem', height: '2.5rem'}}>
            <span className="visually-hidden">Uploading...</span>
          </div>
        </div>
      )}
      {error && (
        <div className="alert alert-danger text-center py-2 mt-2">{error}</div>
      )}
      {/* Progress bar for number progress (preview image upload) */}
      {isNumberProgress && progress > 0 && progress < 100 && (
        <div className="progress mt-2">
          <div
            className="progress-bar"
            role="progressbar"
            style={{ width: `${progress}%` }}
            aria-valuenow={progress}
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
          <span className="ms-2 small">{progress}%</span>
        </div>
      )}
      {children}
    </div>
  );
};

export default ResourceFileUpload;
